import { render, staticRenderFns } from "./project_vulnerability_report.vue?vue&type=template&id=7145ecba&"
import script from "./project_vulnerability_report.vue?vue&type=script&lang=js&"
export * from "./project_vulnerability_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports